import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=45edc62e&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45edc62e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45edc62e')) {
      api.createRecord('45edc62e', component.options)
    } else {
      api.reload('45edc62e', component.options)
    }
    module.hot.accept("./remark.vue?vue&type=template&id=45edc62e&scoped=true&", function () {
      api.rerender('45edc62e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overdue/remark.vue"
export default component.exports